<template>
  <div v-if="magnoliaGetters.showKioskOrCatalog($flags, showColumnKiosk, showColumnCatalog)">
    <KikAccordion
      v-if="$device.isMobile && mobileDisplayMode === 'accordion'"
      :index="0"
      :title="title"
      class="border-t-transparent pb-5 pt-0"
    >
      <EditableArea
        v-if="links"
        :content="links"
      />
    </KikAccordion>
    <template v-else>
      <p class="mb-4 text-lg font-bold">
        {{ title }}
      </p>
      <EditableArea
        v-if="links"
        :content="links"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { magnoliaGetters } from '~/composables/getters';

interface Props {
  title?: string | undefined;
  links?: any;
  showColumnKiosk?: boolean;
  showColumnCatalog?: boolean;
}

withDefaults(defineProps<Props>(), {
  title: undefined,
  links: undefined,
  showColumnKiosk: true,
  showColumnCatalog: true,
});
const { $flags } = useNuxtApp();
const mobileDisplayMode = inject('mobileDisplayMode', 'accordion');
</script>
